import { Novo } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Novo';
import { createAnimations } from '@tamagui/animations-css';

import { AnimationName } from './animationTypes';

export const animationMap: { [k in AnimationName]: string } = {
  accelerateDecelerateFastest: Novo.animation.timing.accelerateDecelerateFastest.web,
  accelerateDecelerateFast: Novo.animation.timing.accelerateDecelerateFast.web,
  accelerateDecelerateSlow: Novo.animation.timing.accelerateDecelerateSlow.web,
  decelerateFastest: Novo.animation.timing.decelerateFastest.web,
  decelerateFast: Novo.animation.timing.decelerateFast.web,
  accelerateFast: Novo.animation.timing.accelerateFast.web,
  accelerateSlow: Novo.animation.timing.accelerateSlow.web,
  responsiveAccelerate: Novo.animation.timing.responsiveAccelerate.web,
  linear: Novo.animation.timing.linear.web,
  contentfulArchAnimation: Novo.animation.timing.contentfulArchAnimation.web,
};

export const animations = createAnimations(animationMap);
